import EzController from 'controllers/ez-base-controller';
import FacebookLogin from 'lib/facebook-login';
import GoogleLogin from 'lib/google-login';
import { triggerCustomEvent } from 'lib/helpers';
import events from 'lib/events';
import Cookies from 'js-cookie';
import { sessionViewActivity, sessionDownloadActivity } from 'lib/sessions-manager';

export default class SocialSessionButtonsController extends EzController {
  static targets = [
    'fbButton',
    'fbText',
    'googleButton',
    'googleText',
  ];

  connect() {
    this.connectType = this.element.dataset.connectType;

    Cookies.set('sessionViewActivity', sessionViewActivity());
    Cookies.set('sessionDownloadActivity', sessionDownloadActivity());

    this.facebook = new FacebookLogin({
      buttonTarget: this.fbButtonTarget,
      textTarget: this.hasFbTextTarget ? this.fbTextTarget : null,
      csrfToken: this.csrfToken,
      omniauthToken: this.element.dataset.omniauthToken,
    });

    this.google = new GoogleLogin({
      buttonTarget: this.googleButtonTarget,
      textTarget: this.hasGoogleTextTarget ? this.googleTextTarget : null,
      csrfToken: this.csrfToken,
      omniauthToken: this.element.dataset.omniauthToken,
    });
  }

  connectFacebook = () => {
    // login_with_facebook
    // create_account_with_facebook
    triggerCustomEvent(events.sessions.social[`${this.connectType}_with_facebook`]);

    this.facebook.connect();
  }

  connectGoogle = () => {
    // login_with_google
    // create_account_with_google
    triggerCustomEvent(events.sessions.social[`${this.connectType}_with_google`]);

    this.google.connect();
  }
}
